const Rojito = ({ isActiveWomensMode }) => {
    return (
        <>
            <div className='FrontPage--Riddle__Screen__Background'>
                {isActiveWomensMode ? (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='FrontPage--Riddle__Screen__Background__Image' />
                ) : isActiveWomensMode === false && (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Varonil.png' className='FrontPage--Riddle__Screen__Background__Image' />
                )}
            </div>

            <div className="FrontPage--Riddle__Screen__Container">
                <img src='/img/page/adsl-five.png' className='FrontPage--Riddle__Screen__Container__Logo' />

                <p className="FrontPage--Riddle__Screen__Container__Title">¡Glup Glup!</p>
                <p className="FrontPage--Riddle__Screen__Container__Subtitle text-center mt-5 fs-1">presentada por</p>
                <img src="/img/games/balloons/male/january-31-2026/Interaktia-Dinamicas-Digitales-Eventos-Deportivos-Rojito-Drinks.png" className="FrontPage--Riddle__Screen__Container__BrandLogo mt-5" />
            </div>


            {/* Lata sola, se rellena y se pinta */}
            {/* <div className="Balloons__Screen__Brands--RojitoDrinks__DrinkBox--V1--V1">
                <div className="Balloons__Screen__Brands--RojitoDrinks__DrinkBox--V1__Water">
                    <div className="Balloons__Screen__Brands--RojitoDrinks__DrinkBox--V1__Glass">
                        <img src="/img/games/balloons/male/january-31-2026/Interaktia-Dinamicas-Digitales-Eventos-Deportivos-Rojito-Lata.png" />
                    </div>
                </div>
            </div> */}

            {/* Vaso rellenado con Rojito */}
            {/* <div className="Balloons__Screen__Brands--RojitoDrinks__DrinkBox--V2">
                <div className="Balloons__Screen__Brands--RojitoDrinks__DrinkBox--V2__Water">
                    <div className="Balloons__Screen__Brands--RojitoDrinks__DrinkBox--V2__Glass"></div>
                </div>
                <div className="Balloons__Screen__Brands--RojitoDrinks__DrinkBox--V2__Bottle Balloons__Screen__Brands--RojitoDrinks__DrinkBox--V2__Bottle--Filling"> {/* Balloons__Screen__Brands--RojitoDrinks__DrinkBox--V2__Bottle--Filling /}
                    <img src="/img/games/balloons/male/january-31-2026/Interaktia-Dinamicas-Digitales-Eventos-Deportivos-Rojito-Lata-Roja.png" className="Balloons__Screen__Brands--RojitoDrinks__DrinkBox--V2__Bottle--Filling__Image" /> {/* Balloons__Screen__Brands--RojitoDrinks__DrinkBox--V2__Bottle--Filling__Image /}
                </div>
            </div> */}

            <footer className='SelfieFan__Screen__QR__Footer FooterCredits'>Hecho con ♥ por Five Digital Minds | 2026</footer>
        </>
    )
}

export { Rojito };